import React from "react";

import { useHistory } from "react-router-dom";

import { Button, Modal } from "shared/ui";
import { TariffTypes, TariffVariant } from "modules/settings/models";

import { FeatureItem, FeatureList, Lead } from "./styles";

const SIMPLE_TIER_FEATURES = [
    "Идеальная замена бумажному меню",
    "Категории и позиции без ограничений",
    "Показ категорий и позиций по времени",
];

const FEATURES_BY_LEVEL: Record<TariffVariant, string[]> = {
    Simple: SIMPLE_TIER_FEATURES,
    SimpleV2: SIMPLE_TIER_FEATURES,
    Basic: [
        "Заказы в зале, на доставку и на вынос",
        "Скидки и промокоды",
        "Интеграция с айко",
    ],
    Advanced: [
        "Оплата в момент заказа картой",
        "Оплата в момент заказа СБП",
        "Выдача чеков без покупки онлайн-кассы",
    ],
};

interface TariffPromptDialogProps {
    level: TariffVariant | null;
    onClose: () => void;
}

export const TariffPromptDialog = ({ level, onClose }: TariffPromptDialogProps) => {
    const history = useHistory();

    if (!level) return null;

    return (
        <Modal
            open
            onClose={onClose}
            maxWidth="xs"
            title={`Доступно начиная с тарифа ${TariffTypes[level]}`}
            actions={
                <>
                    <Button variant="outlined" color="neutral" onClick={onClose}>
                        Не сейчас
                    </Button>
                    <Button
                        variant="contained"
                        onClick={() => {
                            onClose();
                            history.push("/settings/tariff");
                        }}
                    >
                        Подключить
                    </Button>
                </>
            }
        >
            <Lead>А ещё на этом тарифе:</Lead>
            <FeatureList>
                {FEATURES_BY_LEVEL[level].map((feature) => (
                    <FeatureItem key={feature}>{feature}</FeatureItem>
                ))}
            </FeatureList>
        </Modal>
    );
};
